import { render, staticRenderFns } from "./DevListListForDetail.vue?vue&type=template&id=70482889&scoped=true&"
import script from "./DevListListForDetail.vue?vue&type=script&lang=js&"
export * from "./DevListListForDetail.vue?vue&type=script&lang=js&"
import style0 from "./DevListListForDetail.vue?vue&type=style&index=0&id=70482889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70482889",
  null
  
)

export default component.exports